import React, {useState, useEffect} from 'react';
import DraggableList from '../../../common/draggable-list';
import SubSection from '../../../../libs/react-components-admin/section/sub-section';

const PossibleValues = ({value, onChange}) => {

  const [model, setModel] = useState(value || []);

  const setModelAndNotify = newModel => {
    setModel(newModel);
    onChange(newModel);
  };

  useEffect(() => {
    setModel(value || []);
  }, [ value ]);

  const renderItem = (item, i) => {
    return <div className="row">
      <div className="col">
        <input type="text"
               className="form-control"
               placeholder="Enter a value"
               value={item || ''}
               onChange={e => setModelAndNotify(model.map((v, j) => j !== i ? v : e.target.value))}/>
      </div>
      <div className="col-auto">
        <button type="button"
                className="btn btn-danger"
                onClick={() => { setModelAndNotify(model.filter(element => element !== item)) }}>
          <span className="material-icons align-middle">delete</span>
        </button>
      </div>
    </div>;
  }

  const footer = <li className="list-group-item">
    <div className="row">
      <div className="col">
      </div>
      <div className="col-auto">
        <button type="button"
                className="btn btn-success"
                onClick={() => { setModelAndNotify([ ...model, '' ]); }}>
          <span className="material-icons align-middle">add</span>
        </button>
      </div>
    </div>
  </li>;

  return <SubSection className="ms-md-4 mt-3" title="Possible values">
    <DraggableList value={model}
                   onChange={value => setModelAndNotify(value)}
                   itemRenderer={renderItem}
                   footer={footer}/>
  </SubSection>;
}

export default PossibleValues;
